import { Theme } from '../types';

/**
 * Get theme color by index (1-4)
 * 1 = primary, 2 = secondary, 3 = accent, 4 = quaternary
 */
export const getThemeColorByIndex = (theme: Theme, index: number): string => {
  const colors = [theme.primary, theme.secondary, theme.accent, theme.quaternary];
  const validIndex = Math.max(1, Math.min(4, index)); // Clamp between 1-4
  return colors[validIndex - 1] || theme.primary;
};

/**
 * Get all theme colors based on environment variables
 */
export const getThemeColors = (theme: Theme) => {
  const fontColorIndex = Number(import.meta.env.VITE_THEME_FONT_COLOR) || 1;
  const bgColorIndex = Number(import.meta.env.VITE_THEME_BG_COLOR) || 2;
  const borderColorIndex = Number(import.meta.env.VITE_THEME_BORDER_COLOR) || 1;
  const accentColorIndex = Number(import.meta.env.VITE_THEME_ACCENT_COLOR) || 3;

  return {
    font: getThemeColorByIndex(theme, fontColorIndex),
    background: getThemeColorByIndex(theme, bgColorIndex),
    border: getThemeColorByIndex(theme, borderColorIndex),
    accent: getThemeColorByIndex(theme, accentColorIndex),
    // Helper to get original colors if needed
    original: {
      primary: theme.primary,
      secondary: theme.secondary,
      accent: theme.accent,
      quaternary: theme.quaternary
    }
  };
};

/**
 * Get color configuration from environment
 */
export const getColorConfig = () => ({
  fontColorIndex: Number(import.meta.env.VITE_THEME_FONT_COLOR) || 1,
  bgColorIndex: Number(import.meta.env.VITE_THEME_BG_COLOR) || 2,
  borderColorIndex: Number(import.meta.env.VITE_THEME_BORDER_COLOR) || 1,
  accentColorIndex: Number(import.meta.env.VITE_THEME_ACCENT_COLOR) || 3
});